module.exports = __webpack_public_path__ + "static/media/carousel.c73ed37c.svg";